import { Button } from "@powerdiary/components-library/lib";
import { ArrowLeft, ArrowRight, X } from "lucide-react";
import { Box, MobileStepper, mobileStepperClasses } from "@mui/material";
import { STEP_CONFIRMATION } from "../../../bookingSlice.types";
import { useBookingNavigation } from "../../../hooks/useBookingNavigation";
import styles from "./HeaderMobile.module.css";

interface IHeaderMobileProps {
    handlePrevious: () => void;
    handleNext: () => void;
    handleCancel: () => void;
}
export default function HeaderMobile({ handlePrevious, handleCancel, handleNext }: Readonly<IHeaderMobileProps>) {
    const { effectiveStepOrder, effectiveCurrentStep, canGoPrevious, canGoNext } = useBookingNavigation();
    const totalSteps = effectiveStepOrder.length;
    const currentStepIndex = effectiveStepOrder.indexOf(effectiveCurrentStep);
    const currentStep = currentStepIndex >= 0 ? currentStepIndex + 1 : 1;
    const isConfirmationStep = effectiveCurrentStep === STEP_CONFIRMATION;

    return (
        <Box className={styles.mobileButtonGroup} data-test-id="section_header_mobile">
            <Button
                variant="text"
                size="extraSmall"
                startIcon={<ArrowLeft size={14} strokeWidth={2} aria-hidden />}
                onClick={handlePrevious}
                disabled={!canGoPrevious}
                data-test-id="button_mobile_appointment_booking_back"
            >
                BACK
            </Button>

            <MobileStepper
                steps={totalSteps}
                position="static"
                activeStep={currentStep - 1}
                nextButton={<div />}
                backButton={<div />}
                sx={{
                    backgroundColor: "transparent",
                    flexGrow: 0,
                    [`& .${mobileStepperClasses.dots}`]: {
                        justifyContent: "center",
                    },
                }}
                data-test-id="mobile_stepper_appointment_booking"
            />

            {isConfirmationStep ? (
                <Button
                    variant="text"
                    size="extraSmall"
                    endIcon={<X size={14} strokeWidth={2} aria-hidden />}
                    onClick={handleCancel}
                    data-test-id="button_mobile_appointment_booking_cancel"
                >
                    CANCEL
                </Button>
            ) : (
                <Button
                    variant="text"
                    size="extraSmall"
                    endIcon={<ArrowRight size={14} strokeWidth={2} aria-hidden />}
                    onClick={handleNext}
                    disabled={!canGoNext}
                    data-test-id="button_mobile_appointment_booking_next"
                >
                    NEXT
                </Button>
            )}
        </Box>
    );
}
